module.exports = __webpack_public_path__ + "images/external_images/svg/icons/015-harddisk.svg";